import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { XsI18nPipe } from '@nx-fe/pipes';
import { XDeviceService } from '@nx-fe/services';
import {
  Room,
  SabhaCallService,
  SabhaChatNotificationService,
  SabhaChatService,
  UserRepository,
} from '@soti/sabha-components';
import { SabhaService } from '../../sabha.service';
import { SabhaState } from '../../store/reducers';
import * as fromSabha from '../../store/selectors';
import { XSightRoom } from './xsight-room';

@Injectable()
export class XSightRoomFactory {
  constructor(
    private userRepository: UserRepository,
    private chatService: SabhaChatService,
    private chatNotificationService: SabhaChatNotificationService,
    private callService: SabhaCallService,
    private sabhaService: SabhaService,
    private store: Store<SabhaState>,
    private deviceService: XDeviceService,
    private xsI18nPipe: XsI18nPipe,
  ) { }

  public create(sabhaRoom: Room): XSightRoom {
    return new XSightRoom(
      sabhaRoom,
      this.userRepository,
      this.chatService,
      this.chatNotificationService,
      this.callService,
      this.sabhaService,
      this.deviceService,
      this.xsI18nPipe,
      this.store.select(fromSabha.getRcDevice),
      this.store.select(fromSabha.getRingRoomIds),
      this.store.select(fromSabha.getMcConnections),
    );
  }
}
